import { http } from 'http';
import { createPaginationQuery } from 'helpers/store';
import { getQueryFilters } from 'utils/filters';

export default {
  fetch: fields =>
    http.get(fields ? `/partners?fields=${fields}&limit=200` : '/partners?limit=200'),

  fetchPartnerById: ({ partnerId, fields }) =>
    http.get(fields ? `/partners?id=${partnerId}&fields=${fields}` : `/partners?id=${partnerId}`),

  partnerById: partnerId => http.gidet(`/partners/${partnerId}`),

  campaignsByPartnerId: ({ partnerId, pagination }) =>
    http.get(`/partners/${partnerId}/campaigns${createPaginationQuery(pagination)}`),

  operationsByPartnerId: partnerId => http.get(`/partners/${partnerId}/operations`),

  operationsByPartnerIdSummaryB2C: ({ partnerId, pagination, filters }) =>
    http.get(
      `/partners/${partnerId}/operations/summary${createPaginationQuery(
        pagination
      )}${getQueryFilters(filters)}`
    ),

  operationsByPartnerIdSummaryB2B: ({ partnerId, pagination, filters }) =>
    http.get(
      `/b2b/${partnerId}/operations/summary${createPaginationQuery(pagination)}${getQueryFilters(
        filters
      )}`
    ),

  expirationsByPartnerIdSummary: ({ partnerId, pagination, filters }) =>
    http.get(
      `/partners/${partnerId}/expirations/summary${createPaginationQuery(
        pagination
      )}${getQueryFilters(filters)}`
    )
};
